<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog v-model="dialog" persistent width="500" class="border-radius-3" hide-overlay>
            <v-card class="border-radius-3 pa-7" color="#e9f5f4">
                <v-row class="d-flex justify-center mb-5">
                    <v-card-title class="px-5 "
                        ><span class="titles text-h5 font-weight-regular primary--text">{{
                            $t('initialTour.finish_msg')
                        }}</span></v-card-title
                    >
                    <v-card-text class=""
                        ><span
                            class="primary--text subtitle-1 text-body-1"
                            v-html="finish_message"
                        ></span
                    ></v-card-text>
                </v-row>

                <v-card-actions class="d-flex justify-center">
                    <v-btn data-cy="continue-button-finish-survey" color="secondary px-15" large rounded @click="nextPass">{{
                        $t('initialTour.continue')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
            course: (state) => state.userData.user.course,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        finish_message() {
            // eslint-disable-next-line no-nested-ternary
            const username = this.user.firstname.split(' ')[0]
            return `${this.$t('initialTour.previous_diagnostic_msg', { username })}`
        },
    },
    methods: {
        ...mapActions('dashboard', [
            'showDiagnosticTutorialModal',
            'showFinishSurveyModal',
            'showFinishOnBoardingModal',
            'mountDiagnostic'
        ]),
        nextPass() {
            this.showFinishSurveyModal();
            const isPregrade = ['G0'].some(g => this.grade === g);
            if (!isPregrade && this.diagnosticData && this.diagnosticData.length) {
                this.mountDiagnostic();
                return
            }

            this.showFinishOnBoardingModal();
        },
    },
    mixins: [initialReaderValidation]
}
</script>
<style>
.avatar-stars {
    background: url(../../assets/img/effects/avatar-stars.svg) round;
}
</style>
